import { NodeQuery } from '../NodeQuery/NodeQuery';

import type { JSX } from 'react';

interface IProps {
  collectionName: string;
  id: string | null;
  associationName: string;
  children: (associatedId: string | null) => JSX.Element;
}

const AssociatedIdQuery = (props: IProps) => (
  <NodeQuery
    collectionName={props.collectionName}
    id={props.id}
    fieldDefs={[`${props.associationName}.id`]}
  >
    {(loading, node) => {
      const associatedId: string | null =
        (node &&
          node._Associations &&
          node._Associations[props.associationName] &&
          node._Associations[props.associationName].id) ||
        null;
      return props.children(associatedId);
    }}
  </NodeQuery>
);

export default AssociatedIdQuery;
